import { useState, useEffect } from "react";
import { calcUIDimensions } from "../common/helpers";

export function useIsPortrait() {
  const [isPortrait, setIsPortrait] = useState(calcIsPortrait());

  useEffect(() => {
    let currentOrientation = calcIsPortrait();
    let timer = null;

    const setScreenOrientation = () => {
      const newOrientation = calcIsPortrait();
      clearTimeout(timer);
      
      if (newOrientation !== currentOrientation) {
        currentOrientation = newOrientation;
        setIsPortrait(newOrientation);
        calcUIDimensions();
      } else {
        timer = setTimeout(calcUIDimensions, 100);
      }
    };

    window.addEventListener("resize", setScreenOrientation);
    window.addEventListener("orientationchange", setScreenOrientation);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", setScreenOrientation);
      window.removeEventListener("orientationchange", setScreenOrientation);
    };
  }, []);

  return isPortrait;
}

const calcIsPortrait = () => window.innerWidth <= window.innerHeight && window.innerWidth < 512;